module.exports = __webpack_public_path__ + "static/hero-f8f4c57c0e853156b30d1a55b4db5edd.jpg";